// extracted by mini-css-extract-plugin
export default {"wxLauchHack":"index_wxLauchHack_zWlsK"};